import { ArrowDownRight, ArrowUpRight, BriefcaseBusiness, CircleDollarSign, RotateCcw, ShieldCheck } from 'lucide-react';
import { formatInr } from '../utils/market.js';

export default function Portfolio({ stocks, portfolio, onSelectStock, onReset }) {
  const holdings = Object.entries(portfolio.holdings).map(([symbol, position]) => {
    const stock = stocks.find((item) => item.symbol === symbol);
    const value = stock ? position.quantity * stock.price : 0;
    const cost = position.quantity * position.averagePrice;
    return { ...position, symbol, stock, value, cost, pnl: value - cost };
  });
  const holdingsValue = holdings.reduce((sum, item) => sum + item.value, 0);
  const invested = holdings.reduce((sum, item) => sum + item.cost, 0);
  const total = portfolio.cash + holdingsValue;
  const pnl = holdingsValue - invested;

  return (
    <div className="page-stack">
      <section className="page-heading compact-page-heading">
        <div><div className="eyebrow"><BriefcaseBusiness size={12} /> Risk-free practice</div><h1>Paper portfolio</h1><p>Test a process with virtual money. Nothing here places or routes a real order.</p></div>
        <button className="subtle-button" onClick={onReset}><RotateCcw size={15} /> Reset simulation</button>
      </section>
      <section className="portfolio-summary">
        <article><span>Total value</span><strong>{formatInr(total)}</strong><small>Virtual account</small></article>
        <article><span>Holdings</span><strong>{formatInr(holdingsValue)}</strong><small>{holdings.length} positions</small></article>
        <article><span>Available cash</span><strong>{formatInr(portfolio.cash)}</strong><small>Not withdrawable</small></article>
        <article><span>Unrealised P&L</span><strong className={pnl >= 0 ? 'positive' : 'negative'}>{pnl >= 0 ? '+' : ''}{formatInr(pnl)}</strong><small>Illustrative only</small></article>
      </section>
      <section className="surface-card positions-card">
        <header className="card-header"><div><h2>Open positions</h2><p>Mark-to-market using the current dashboard snapshot.</p></div><span className="policy-note"><ShieldCheck size={14} /> Simulation</span></header>
        <div className="table-wrap"><table><thead><tr><th>Company</th><th>Quantity</th><th>Avg. price</th><th>Current</th><th>Value</th><th>P&L</th></tr></thead><tbody>
          {holdings.map((item) => (
            <tr key={item.symbol} onClick={() => onSelectStock(item.symbol)}>
              <td><div className="company-cell"><span className="stock-monogram">{item.symbol.slice(0, 2)}</span><span><strong>{item.symbol}</strong><small>{item.stock?.name}</small></span></div></td>
              <td className="numeric">{item.quantity}</td><td className="numeric">{formatInr(item.averagePrice)}</td><td className="numeric">{formatInr(item.stock?.price || 0)}</td><td className="numeric">{formatInr(item.value)}</td>
              <td className={`numeric ${item.pnl >= 0 ? 'positive' : 'negative'}`}>{item.pnl >= 0 ? <ArrowUpRight size={13} /> : <ArrowDownRight size={13} />}{formatInr(item.pnl)}</td>
            </tr>
          ))}
        </tbody></table></div>
        {!holdings.length && <div className="empty-state"><CircleDollarSign size={32} /><h3>No paper positions yet</h3><p>Open a stock and use the simulation controls to practise.</p></div>}
      </section>
    </div>
  );
}
